import { AnalyticsBrowser } from '@segment/analytics-next';
import getConfig from 'next/config';

let _analytics: AnalyticsBrowser;

const analytics = (): AnalyticsBrowser => {
  const { segmentToken } = getConfig().publicRuntimeConfig;
  if (!_analytics) {
    _analytics = new AnalyticsBrowser();

    if (segmentToken) {
      _analytics.load({ writeKey: segmentToken });
    }
  }

  return _analytics;
};

export default analytics;
